import React, { useEffect } from "react";
import rCoin from "../../assets/images/r coin 2.png";
import { useDispatch, useSelector } from "react-redux";
import male from "../../assets/images/male.png";
import { assetUrl } from "../../util/assetUrl";
import leftArrow from "../../assets/images/leftArrow.png";
import { getUser } from "../../store/user/action";
import { useNavigate } from "react-router-dom"; // Updated import
import useTranslation from "../../hooks/useTranslation";
import { groupNumber } from "../../util/groupNumber";

const T = {
  pageBg: "var(--mx-bg)",
  text: "var(--mx-text)",
  sub: "var(--mx-text-2)",
  border: "var(--mx-hairline)",
  card: "var(--mx-card)",
  cardSolid: "var(--mx-veil)",
  radius: 16,
  shadow: "var(--mx-shadow-float)",
  // accents
  indigo: "var(--mx-accent)",
  purple: "var(--mx-accent)",
  green: "var(--mx-ok)",
  rose: "var(--mx-pink)",
  // grad* entries render flat (a same-color two-stop gradient); names kept for callers
  gradIndigo: "var(--mx-accent)",
  gradPink: "var(--mx-pink)",
  gradBlue: "var(--mx-info)",
  gradPurple: "var(--mx-accent)",
  gradPink2: "var(--mx-pink)",
  gradepurple2: "var(--mx-card)",
};

export const CreatorDetails = () => {
  const { t, languageCode } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    dispatch(getUser(agencyId));
  }, [dispatch, agencyId]);

  const handleOpenHostHistory = (id) => {
    navigate("/agencypanel/hosthistory", { state: { id } }); // Updated to use navigate
  };

  return (
    <div className="" style={{ borderRadius: "12px", paddingBottom: "28px" }}>
      <div
        className="p-2 creatorDetails"
        style={{
          background: "var(--mx-bg)",
        }}
      >
        {user?.map((data) => (
          <div
            key={data?._id}
            className="p-2 creatorDetails"
            style={{
              background: "var(--mx-bg)",
            }}
          >
            <div
              style={{
                borderRadius: "10px",
                paddingTop: "12px",
                background: "var(--mx-card)",
                backgroundRepeat: "no-repeat",
                border: `1px solid rgba(255,255,255,0.12)`,
                padding: "13px",
              }}
            >
              <div className="bd-content">
                <div className="d-flex">
                  <div>
                    <img
                      src={assetUrl(data?.image, male)}
                      style={{
                        height: "40px",
                        width: "40px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                      alt=""
                    />
                  </div>
                  <div className="ms-3">
                    <div className="d-flex">
                      <p
                        className="mb-0 fw-bolder text-white"
                        style={{ fontSize: "15px" }}
                      >
                        {data?.name ? data?.name : "-"}
                      </p>
                      {/* A "Host" role badge, not an action — it shipped as a <button>
                          with no handler, which reads as a disabled control. */}
                      <span
                        className="text-white"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "1px 10px",
                          background: "var(--mx-accent)",
                          borderRadius: "6px",
                          marginLeft: "10px",
                          fontSize: "13px",
                        }}
                      >
                        {t("Host")}
                      </span>
                    </div>
                    <p
                      className="fw-bolder"
                      style={{ fontSize: "14px", color: "var(--mx-text-2)" }}
                    >
                      {t("ID")} : {data?.uniqueId ? data?.uniqueId : "-"}
                    </p>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{ width: "100%" }}
                >
                  <div
                    style={{
                      background: T.gradPink2,
                      color: "var(--mx-text)",
                      padding: "3px 8px",
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: 14,
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      boxShadow: T.shadow,
                    }}
                  >
                    <span style={{ fontWeight: 400 }}>
                      {t("host_income")} :
                    </span>
                    <img src={rCoin} alt="" height={20} width={20} />
                    {groupNumber(data?.currentCoin, languageCode)}
                  </div>

                  <button
                    style={{
                      border: "none",
                      background: "none",
                      // Text + 22px chevron measured 25px tall — below the touch floor.
                      minHeight: 36,
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "0 4px",
                    }}
                    onClick={() => handleOpenHostHistory(data?._id)}
                  >
                    <p
                      className="mb-0 history"
                      style={{
                        color: "var(--mx-text-2)",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                    >
                      {t("history")}
                      <img
                        src={leftArrow}
                        alt=""
                        height={22}
                        width={22}
                        style={{ marginLeft: "5px" }}
                      />
                    </p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
